<template>
  <div class="wrap">
    <!-- <video class="wrapVideo" autoplay muted loop>
      <source
        src="https://video.isc.360.com/vod-iscvideo-vod-101179-beijing/TL38d747c45fbd16679b6f2a4725dc6278.mp4"
        type="video/mp4"
      />
      您的浏览器不支持 video 标签。
    </video> -->
    <!-- <img class="wrapVideo" src="https://p4.ssl.qhimg.com/t01bc2b2e9d108de39b.jpg" alt="背景图" />
    <div class="wrapMask"></div>
    <img class="wrapText" src="https://p4.ssl.qhimg.com/t01bc418769fe9ab8ad.png" alt="文字" /> -->
    <img src="https://p1.ssl.qhimg.com/t012395a513adf23dbd.jpg" alt="背景图" class="wrapPicture">
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  // height: 360px;
  overflow: hidden;
  margin-top: 48px;
  &Picture {
    width: 100%;
    height: 100%;
  }
  // &Video {
  //   display: inline-block;
  //   width: 100%;
  //   height: 100%;
  // }
  // &Mask {
  //   position: absolute;
  //   top: 0;
  //   width: 100%;
  //   height: 100%;
  //   background-color: rgba(0, 0, 0, 0.5);
  // }
  // &Text {
  //   position: absolute;
  //   top: 50%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);
  //   width: 170px;
  // }
}
</style>
